const menuInit = () => {
  const btnOpenElement = document.getElementById('js-header-mobile-open');
  const btnCloseElement = document.getElementById('js-header-mobile-close');

  if (btnOpenElement) {
    btnOpenElement.addEventListener('click', menuOpen);
  }

  if (btnCloseElement) {
    btnCloseElement.addEventListener('click', menuClose);
  }

  window.addEventListener('resize', menuOnResize);
};

const menuOpen = () => {
  const bodyElement = document.querySelector('body');
  const menuElement = document.getElementById('js-header-mobile-menu');

  if (menuElement && bodyElement) {
    if (menuElement.className === 'menu') {
      menuElement.setAttribute('class', 'menu open');
      bodyElement.setAttribute('class', 'noscroll');
    }
  }
};

const menuClose = () => {
  const bodyElement = document.querySelector('body');
  const menuElement = document.getElementById('js-header-mobile-menu');

  if (menuElement && bodyElement) {
    if (menuElement.className === 'menu open') {
      menuElement.setAttribute('class', 'menu');
      bodyElement.setAttribute('class', '');
    }
  }
};

const menuOnResize = () => {
  const bodyElement = document.querySelector('body');
  const menuElement = document.getElementById('js-header-mobile-menu');

  if (menuElement && bodyElement) {
    menuElement.setAttribute('class', 'menu');
    bodyElement.setAttribute('class', '');
  }
};

export default menuInit;
